/* Product-card row alignment (Juan, 2026-10-13: "the length, ring and shape of these cards to
   always line up"). Titles show IN FULL and wrap to 2-7 lines, so Length/Ring/Shape started at a
   different height on every card. This gives every title in the same visual row the height of
   the tallest title in that row, so the spec rows line up across the row. Nothing is clipped.
   Inline min-height is set with priority because the theme's .card__heading rules use !important.
   Re-runs on resize, font load, image load and when the grid is replaced (filters / pagination). */
(function () {
  var SEL = '.card-wrapper .card__information > .card__heading';
  var queued = false;
  function align() {
    queued = false;
    var heads = Array.prototype.slice.call(document.querySelectorAll(SEL));
    if (!heads.length) return;
    heads.forEach(function (h) { h.style.removeProperty('min-height'); });
    var groups = new Map();
    heads.forEach(function (h) {
      var item = h.closest('.card-wrapper');
      if (!item || !item.getClientRects().length) return;           // hidden (e.g. closed drawer)
      var list = item.closest('ul, .grid, .slider') || document.body;
      var top = Math.round(item.getBoundingClientRect().top + window.scrollY);
      var byTop = groups.get(list);
      if (!byTop) { byTop = {}; groups.set(list, byTop); }
      (byTop[top] = byTop[top] || []).push(h);
    });
    groups.forEach(function (byTop) {
      Object.keys(byTop).forEach(function (k) {
        var row = byTop[k];
        if (row.length < 2) return;
        var max = 0;
        row.forEach(function (h) { max = Math.max(max, h.getBoundingClientRect().height); });
        row.forEach(function (h) { h.style.setProperty('min-height', Math.ceil(max) + 'px', 'important'); });
      });
    });
  }
  /* setTimeout, not requestAnimationFrame: rAF never fires in a background tab, so a page opened
     behind another tab would stay unaligned until something else triggered a pass. */
  function schedule() { if (!queued) { queued = true; setTimeout(align, 60); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  document.addEventListener('visibilitychange', schedule);
  /* Width changes that do not raise a resize event (rotation on some iPads, emulated viewports). */
  if (typeof ResizeObserver !== 'undefined') {
    var lastW = 0;
    new ResizeObserver(function () {
      var w = document.documentElement.clientWidth;
      if (w !== lastW) { lastW = w; schedule(); }
    }).observe(document.documentElement);
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') schedule(); }, true);
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes.length) { schedule(); return; } }
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
